export default __webpack_public_path__ + "static/media/OregonCrest.1810756e.png";